import CalendarLocale from '../calendar/fi_FI';
import TimePickerLocale from '../time-picker/fi_FI';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'Valitse pÃ¤ivÃ¤',
    rangePlaceholder: ['Alku pÃ¤ivÃ¤', 'Loppu pÃ¤ivÃ¤'],
    ...CalendarLocale,
  },
  timePickerLocale: {
    ...TimePickerLocale,
  },
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;
